import type { GetIssueAssessmentAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetIssueAssessmentAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetIssueAssessmentAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetIssueAssessmentAuditByIdArgs = { id: string };

export const useGetIssueAssessmentAuditById = createQueryHook<
  UseGetIssueAssessmentAuditByIdArgs,
  GetIssueAssessmentAuditByIdResponseRow[],
  GetIssueAssessmentAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getIssueAssessmentAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ issue_assessment_audit: data }),
  graphqlDocument: GetIssueAssessmentAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
